module.exports = __webpack_public_path__ + "img/subriena.eec0e5f7.jpg";